import { MESSAGES } from 'src/modules/common/constants.ts';
import { memo, useContext, useState, PropsWithChildren } from 'react';
import { ConfigContext } from 'src/configContext.ts';
import { Button } from 'src/modules/common/components/Button/Button';
import { CrossIcon } from 'src/modules/common/icons/CrossIcon';
import { RuntimeContext } from 'src/runtimeContext';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { Sidebar } from 'src/modules/common/components/Sidebar/Sidebar';
import { Filter, FilterConfig } from 'src/utils/composeFilter';
import { CheckboxHandler } from 'src/modules/common/types/CheckboxHandler';
import { FilterSidebarActions } from 'src/common/FilterSidebarActions/FilterSidebarActions';
import clsx from 'clsx';

type Props = PropsWithChildren<{
    filter: Filter;
    config: FilterConfig;
    checkboxHandler: CheckboxHandler;
}>;

export const AccessoriesSidebarComponent = memo(({
    filter,
    config,
    checkboxHandler,
    children,
}: Props) => {
    const { isMobile } = useContext(RuntimeContext);
    const { rootElement } = useContext(ConfigContext);

    const [isFilterSidebarOpened, setFilterSidebarOpened] = useState(false);

    return (
        <div className={clsx({
            'vss-filter-sidebar-component': true,
        })}
        >
            {isMobile ? (
                <>
                    <FilterSidebarActions
                        useTranslate={true}
                        filter={filter}
                        config={config}
                        handleFilterSidebarOpen={() => setFilterSidebarOpened(true)}
                        filterCloseHandler={checkboxHandler}
                        buttonKind="tertiary"
                    />

                    <Sidebar
                        opened={isFilterSidebarOpened}
                        handleClose={() => setFilterSidebarOpened(false)}
                        root={rootElement}
                    >
                        <div className={clsx({
                            'vss-filter-sidebar-component': true,
                        })}
                        >
                            <div className="vss-filter-sidebar-component__header">
                                <p className="vss-filter-sidebar-component__name">
                                    <I18n messageId={MESSAGES.modalFilterAccessoriesLabel}/>
                                </p>

                                <Button
                                    className="vss-filter-sidebar-component__button"
                                    onClick={() => setFilterSidebarOpened(false)}
                                    size="sm"
                                    iconOnly={true}
                                    kind="ghost"
                                >
                                    <div className="vss-filter-sidebar-component__icon">
                                        <CrossIcon/>
                                    </div>
                                </Button>
                            </div>
                            <div className="vss-filter-item-wrapper">
                                <div className="vss-filter-values-group">
                                    <div className="vss-filter-values-group__options">
                                        {children}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Sidebar>
                </>
            ) : (
                <div className="vss-filter-item-wrapper">
                    <div className="vss-accessories-filter-values-group">
                        <div className="vss-accessories-filter-values-group__header">
                            <div className="vss-accessories-filter-values-group__title">
                                <I18n messageId={MESSAGES.modalFilterAccessoriesLabel}/>
                            </div>
                        </div>
                        <div className="vss-accessories-filter-values-group__options">
                            {children}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
});
